import { request } from '../request'

// 获取SurveyID的方法
export function getOrInitAgentSurvey() {
  return request({
    url: '/wenjuan/wjsurvey/getOrInitAgentSurvey',
    method: 'get'
  })
}

// 代理商标表头数据
export function getTableHeader(params) {
  return request({
    url: '/quota/wjEntrustAgent/header',
    method: 'get',
    params
  })
}

// 代理商删除
export function deleteTable(params) {
  return request({
    url: `/quota/wjEntrustAgent/delete`,
    method: 'get',
    params
  })
}

// 代理商详情页面多条件搜索
export function searchAgent(params) {
  return request({
    url: `/quota/wjEntrustAgent/searchAgent`,
    method: 'get',
    params
  })
}

// 导出代理商详情
export function exportAgent(data) {
  return request({
    url: `/quota/wjEntrustAgent/exportExcel`,
    method: 'post',
    responseType: 'blob',
    data
  })
}
